import { ValidationError } from "sequelize"
import {
    MtMailSettings,
    MtMailTemplate,
} from "server/models"
import { GET, POST, validate } from "client/store/utils"
import { LangType } from "client/store"
import { BalloonMessage } from "client/components"
import {
    MailMessage,
    MailSettingsValidation,
    MailTemplateValidation,
} from "./types"

// send mail

export const SendMail = (message: MailMessage) => (
    POST(
        "/mtMail/send",
        JSON.stringify(message),
    ).then(([err, reply]) => {
        if (err) {
            BalloonMessage(err.response)
        }
        return [err, reply]
    })
)

// settings

export const LoadAllMailSettings = () => (
    GET("/mtMailSettings/all")
    .then((settings: MtMailSettings[]) => settings)
)

export const LoadMailSettingByName = (name: string) => (
    GET(`/mtMailSettings/name/${name}`)
    .then((setting: MtMailSettings) => setting)
)

export const SaveMailSetting = (
    data: MtMailSettings,
    lang: LangType,
) => (
    POST(
        "/mtMailSettings/save",
        JSON.stringify(data),
    ).then((res) => {
        const error = res as ValidationError
        return {
            validation: <MailSettingsValidation>validate(error, lang),
        }
    })
)

// templates

export const LoadAllMailTemplates = () => (
    GET("/mtMailTemplate/all")
    .then((templates: MtMailTemplate[]) => templates)
)

export const LoadMailTemplateByName = (name: string) => (
    GET(`/mtMailTemplate/name/${name}`)
    .then((template: MtMailTemplate) => template)
)

export const SaveMailTemplate = (
    data: MtMailTemplate,
    lang: LangType,
) => (
    POST(
        "/mtMailTemplate/save",
        JSON.stringify(data),
    ).then((res) => {
        const error = res as ValidationError
        return {
            validation: <MailTemplateValidation>validate(error, lang),
        }
    })
)
